import axios from 'axios';

const DailyRegister = {
    namespaced: true,
    actions: {
        CreatePortalDailyRegister({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .post(
                        `${process.env.VUE_APP_ENV_API_URL}PortalDailyRegister/CreatePortalDailyRegister`,
                        payload,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        UpdatePortalDailyRegister({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .post(
                        `${process.env.VUE_APP_ENV_API_URL}PortalDailyRegister/UpdatePortalDailyRegister`,
                        payload,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        SignInPortalDailyRegister({ rootState }, userdata) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .post(
                        `${process.env.VUE_APP_ENV_API_URL}PortalDailyRegister/SignInPortalDailyRegister`,
                        userdata,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        console.log("Responded from Sign In Error || ", err);
                        reject(err);
                    });
            });
        },
        SignOutPortalDailyRegister({ rootState }, userdata) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .post(
                        `${process.env.VUE_APP_ENV_API_URL}PortalDailyRegister/SignOutPortalDailyRegister`,
                        userdata,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        CommentOnPortalDailyRegister({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .post(
                        `${process.env.VUE_APP_ENV_API_URL}PortalDailyRegister/CommentOnPortalDailyRegister`,
                        payload,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        ConfirmPortalDailyRegister({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .post(
                        `${process.env.VUE_APP_ENV_API_URL}PortalDailyRegister/ConfirmPortalDailyRegister`,
                        payload,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
         CreatePortalDailyAttendance({ rootState }, payload) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .post(
                        `${process.env.VUE_APP_ENV_API_URL}PortalDailyRegister/CreatePortalDailyAttendance`,
                        payload,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        GetPortalDailyRegisterById({ rootState }, { PortalDailyRegisterId }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}PortalDailyRegister/GetPortalDailyRegisterById?PortalDailyRegisterId=${PortalDailyRegisterId}`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        GetPortalDailyRegister({ rootState }, { SearchValue, PageNumber, PageSize }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}PortalDailyRegister/GetPortalDailyRegister?SearchValue=${SearchValue}&PageNumber=${PageNumber}&PageSize=${PageSize}`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        GetLastStudentDailyAttendanceTaken({ rootState }) {
            return new Promise((resolve, reject) => {
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`,
                };
                axios
                    .get(
                        `${process.env.VUE_APP_ENV_API_URL}PortalDailyRegister/GetLastStudentDailyAttendanceTaken`,
                        { headers }
                    )
                    .then((resp) => resp.data)
                    .then((data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
    }
}

export default DailyRegister